import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import renderSearchBox from '../../../../components/ui/forms/renderSearchBox'
import formValidators from '../../../../utils/validation/formValidators'

class FeedSearchForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    this.onSubmit = event => {
      event.preventDefault()
      const { validate } = this.props
      const errors = validate({ searchTerm: this.props.searchTermValue })
      if (errors && errors.searchTerm) return

      this.props.onSubmit(1)
    }
  }

  render() {
    return (
      <form style={{ marginBottom: 15 }} onSubmit={this.onSubmit}>
        <div>
          <div className="row m-0">
            <div className="col p-0">
              <Field
                className="LoNotSensitive"
                name="searchTerm"
                component={renderSearchBox}
                placeholder="Search by keywords (ex. Resume Tips, Interview Advice...)"
              />
            </div>
          </div>
        </div>
      </form>
    )
  }
}

const validate = values => {
  const errors = {}
  errors.searchTerm = formValidators.isRequired(values.searchTerm)
    ? formValidators.isRequired(values.searchTerm)
    : formValidators.maxLengthTwoHundred(values.searchTerm)

  return errors
}

const formified = reduxForm({
  form: 'feedSearchForm',
  validate,
  destroyOnUnmount: false,
})(FeedSearchForm)

const selector = formValueSelector('feedSearchForm')

const mapStateToProps = state => ({
  searchTermValue: selector(state, 'searchTerm'),
})

export default connect(mapStateToProps)(formified)



// WEBPACK FOOTER //
// ./src/routes/authenticated/Dashboard/components/FeedSearchForm.js